export default __webpack_public_path__ + "static/media/i131vp.a7281ed3.webp";